export default function () {
  this.prepareEmail()
}



// WEBPACK FOOTER //
// ./src/app/professional/company/addresses/form/resources/mounted.js